import { render, staticRenderFns } from "./FoldingButton.vue?vue&type=template&id=3d70ed6a&"
import script from "./FoldingButton.vue?vue&type=script&lang=js&"
export * from "./FoldingButton.vue?vue&type=script&lang=js&"
import style0 from "./FoldingButton.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports